import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('User-index-1992f2b8c4056cf4c-1'),
    routerUrl: '/User',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./User')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('User-index-1992f2b8c4056cf4c-2'),
        routerUrl: '/UserForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./UserForm')),
      },
      //$MORE$
    ],
  },
];
